import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS, QUERY_KEYS } from '~shared/api/query-keys';

export interface UpdateGHLCalendarLinkParam {
  classId: string;
  ghlCalendarLink: string;
}

export const updateGHLCalendarLinkAPI = async (
  params: UpdateGHLCalendarLinkParam,
) => {
  const rawPayload = {
    calendarId_ghl: params.ghlCalendarLink,
  };

  const resp = await baseAPI.patch<unknown>(`enrollments/${params.classId}`, {
    payload: JSON.stringify(rawPayload),
  });
  return resp.data;
};

export const useUpdateGHLCalendarLinkMutation = () => {
  return useMutation({
    mutationFn: async (params: UpdateGHLCalendarLinkParam) => {
      const response = await updateGHLCalendarLinkAPI(params);
      return response;
    },
    onSuccess: (_, params) => {
      void queryClient.invalidateQueries({
        queryKey: QUERY_KEYS.CLASSES(),
      });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.CLASSES, params.classId],
      });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.BOOKING_LINK, params.classId],
      });
    },
  });
};
